export default {
    setBreadcrumb({ commit }, breadcrumb) {
        commit("SET_BREADCRUMB", breadcrumb);
	},

	setUnreadNotifications({ commit }, notifications) {
        commit("SET_UNREADNOTIFICATIONS", notifications);
	},

	removeUnreadNotification({ commit }, notification) {
        commit("REMOVE_UNREADNOTIFICATION", notification);
	},

	addUnreadNotification({ commit }, notification) {
        commit("ADD_UNREADNOTIFICATION", notification);
	},
};
